import { useCallback } from 'react';
import { captureEvent } from '../../lib/analytics';
import { ModalType, ConcernFlagData } from './types-constants';

export function useConcernFlagModal(
  openModal: (type: ModalType, data?: Record<string, unknown>) => void
) {
  const triggerConcernFlag = useCallback(
    (data?: ConcernFlagData) => {
      openModal(ModalType.CONCERN_FLAG, data);

      captureEvent('Safety_ConcernModalOpened', {
        screen: data?.screen || 'modal',
        triggered_by: data?.analysisId ? 'analysis_action' : 'banner_button',
      });
    },
    [openModal]
  );

  return {
    triggerConcernFlag,
  };
}
